import React from 'react';
import styled from 'styled-components';
import MobileMenu from "../MobileMenu";

const Ul = styled.ul`
  list-style: none;
  overflow-y: auto;
  font-size: 15px;
  display: flex;
  flex-flow: row nowrap;
  padding-right: 0;
  li {
    padding: 18px 10px;
  }
  flex-flow: column nowrap;
    background-color: #ffffff;
    box-shadow: 0px 5px 2px 3px #d3d3d34f;
    position: fixed;
    transform: ${({open}) => open ? 'translateX(0)' : 'translateX(100%)'};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 1rem;
    transition: transform 0.3s ease-in-out;
    z-index: 99998;
    li {
      color: #000;
    }
    a {
        font-size: 20px;
        margin-top: 5px;
        margin-bottom: 5px;
        padding-right: 10px;
        padding-left: 10px;
        color: #000;
        padding-bottom: 15px;
    }
`;

const LogoDiv = styled.div`
  text-align: center;

  img {
    width: 60px !important;
  }
`

const RightNav = ({logo, toggle, open}) => {

    return (
        <Ul open={open}>
            <LogoDiv>
                {logo}
            </LogoDiv>
            {/*<div className="text-center position-relative">
                <div className="d-flex align-items-center justify-content-center">
                    {login_panel}
                </div>
            </div>*/}
            <MobileMenu toggleMenu={() => toggle()}/>
        </Ul>
    )
}

export default RightNav
